import { Yup } from "lib/extendYup";

export const manualResultsValidationSchema = Yup.object().shape({
  dateRecorded: Yup.date()
    .typeError("Please enter correct date in format DD-MM-YYYY")
    .required("Test date is required"),
  timeRecorded: Yup.string().required("Test time is required"),
  haemoglobin: Yup.object().shape({
    value: Yup.string()
      .required("Haemoglobin level is required")
      .manualResult({ min: 30, max: 270 }, "Haemoglobin level between 30 and 270 g/L is expected"),
  }),
  neutrophils: Yup.object().shape({
    value: Yup.string()
      .required("Neutrophil count is required")
      .manualResult({ min: 0.4, max: 20 }, "Neutrophil count between 0.4 and 20 10⁹/L is expected"),
  }),
  platelets: Yup.object().shape({
    value: Yup.string()
      .required("Platelet count is required")
      .manualResult({ min: 20, max: 600 }, "Platelet count between 20 and 600 10⁹/L is expected"),
  }),
  whiteBloodCells: Yup.object().shape({
    value: Yup.string()
      .required("WBC count is required")
      .manualResult({ min: 0.5, max: 30 }, "WBC count between 0.5 and 30 10⁹/L is expected"),
  }),
});
